import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './messages';
import styles from './styles.module.less';

import type { Config, Widget } from '../config';

type PropertiesPanelProps = {
  config: Config;
  widget: Widget;
  updateWidget: (widget: Widget) => void;
  deleteWidget: (widgetId: string) => void;
  parentWidth: number;
  parentHeight: number;
};

export const PropertiesPanel = ({ config, widget, updateWidget, deleteWidget, parentWidth, parentHeight }: PropertiesPanelProps) => {
  const { definition, properties } = config.widgets[widget.type];

  return (
    <section className={styles.panel}>
      <Text
        className={styles['panel-header']}
        formattedMessageValues={{
          element: definition.ui.label,
        }}
        textType={TextType.H4}
        value={messages.propertyPanelHeader}
      />
      <FlexColumn className={styles.properties}>
        {properties.map(({ id, label, Component }) => (
          <div key={id} className={styles['property-group']}>
            <label className={styles['property-label']} htmlFor={id}>
              {label}
            </label>
            <div className={styles['property-input']}>
              <Component
                id={id}
                parentHeight={parentHeight}
                parentWidth={parentWidth}
                updateWidget={(updated) => updateWidget({ ...widget, ...updated })}
                widget={widget}
              />
            </div>
          </div>
        ))}
        {definition.ui.isBuiltInTemplate ? null : (
          <Button className={styles['delete-button']} onClick={() => deleteWidget(widget.id)} theme={THEME_CONSTANTS.danger}>
            <FormattedMessage {...messages.deleteWidget} />
          </Button>
        )}
      </FlexColumn>
    </section>
  );
};
